// Auth
export const SET_AUTH_TOKEN = 'SET_AUTH_TOKEN'
// App
export const SET_APP_LANGUAGE = 'SET_APP_LANGUAGE'
export const SET_LOGIN_DETAILS = 'SET_LOGIN_DETAILS'
export const SET_SESSION_EXPIRED = 'SET_SESSION_EXPIRED'
export const SET_SERVICE_LOADER = 'SET_SERVICE_LOADER'
export const SET_USER_DETAILS = 'SET_USER_DETAILS'
export const SET_ROLE_ACCESS_DETAILS = 'SET_ROLE_ACCESS_DETAILS'
export const SET_COMPANY_DETAILS = 'SET_COMPANY_DETAILS'
export const SET_PROFILE_IMAGE_DETAILS = 'SET_PROFILE_IMAGE_DETAILS'
export const SET_MENU_DETAILS = 'SET_MENU_DETAILS'
export const SET_SUB_ROLE_ACCESS_DETAILS = 'SET_SUB_ROLE_ACCESS_DETAILS'
export const SET_ROLE_ACCESS_KEY = 'SET_ROLE_ACCESS_KEY'
export const SET_ACCOUNT_LIST = 'SET_ACCOUNT_LIST'
export const SET_ACCOUNT_REFRESH = 'SET_ACCOUNT_REFRESH'
export const SET_CURRENT_ACC_DETAILS = 'SET_CURRENT_ACC_DETAILS'
export const SET_OFFERS = 'SET_OFFERS'
export const SET_BILLERS_LIST = 'SET_BILLERS_LIST'
export const SET_FEATURE_LIST = 'SET_FEATURE_LIST'
export const SET_ACC_CLASS = 'SET_ACC_CLASS'
export const SET_ERROR_MESSAGE = 'SET_ERROR_MESSAGE'
export const SET_MENU_LIST = 'SET_MENU_LIST'

